const FUNNEL_COLORS = ["#4F46E5", "#6366F1", "#818CF8", "#A5B4FC", "#C7D2FE"];

const STEP_LABEL_OVERRIDES = {};

/** Prefer API/mapping label so Main Offer GHL names are not overridden by shared keys. */
export const formatStepLabel = (label, key) =>
  label || STEP_LABEL_OVERRIDES[key] || STEP_LABEL_OVERRIDES[label] || key;

export const getFunnelColor = (index) => FUNNEL_COLORS[index % FUNNEL_COLORS.length];

export const getStepCount = (step, period) =>
  period === "thisWeek" ? step.thisWeek : step.priorWeek;

export const buildFunnelPeriodData = (steps, period) => {
  const values = steps.map((step) => ({
    ...step,
    count: getStepCount(step, period),
  }));

  return values.map((step, index) => {
    const prevCount = index === 0 ? step.count : values[index - 1].count;
    const conversionPercent =
      index === 0
        ? step.count > 0
          ? 100
          : 0
        : prevCount > 0
          ? Number(((step.count / prevCount) * 100).toFixed(1))
          : null;
    const dropOffPercent =
      index === 0
        ? 0
        : prevCount > 0
          ? Number((((prevCount - step.count) / prevCount) * 100).toFixed(1))
          : null;

    return {
      ...step,
      name: step.label,
      value: step.count,
      fill: getFunnelColor(index),
      conversionPercent,
      dropOffPercent,
    };
  });
};

export const buildComparisonChartData = (steps) =>
  steps.map((step) => ({
    name: formatStepLabel(step.label, step.key),
    thisWeek: step.thisWeek,
    priorWeek: step.priorWeek,
  }));

export const getMentorshipPipelineDistribution = (distribution) =>
  (distribution ?? []).filter((item) =>
    item.pipelineName?.toLowerCase().includes("mentorship")
  );
